module.exports = __webpack_public_path__ + "static/media/23.e30906c8.jpg";